import { useEffect } from 'react'
import { syncEndRuleByArmWithAnchors } from '../validation/endRules'
import { useScheduleActions } from './useScheduleActions'

const endRuleSignature = endRules =>
  JSON.stringify(
    (endRules?.rules || []).map(rule => ({
      type: rule.type,
      byArm: rule.byArm,
    })),
  )

/** Keep relative-to-visit end rules aligned with visit anchor arms (defaults + pruning). */
export const useLiveEndRuleByArm = (schedule, entityOptions) => {
  const { updateSchedule } = useScheduleActions()
  const anchorKey = JSON.stringify(
    (schedule.anchors || []).map(anchor => ({
      type: anchor.type,
      instanceId: anchor.instanceId,
      instanceIds: anchor.instanceIds,
      visitRefs: anchor.visitRefs,
    })),
  )

  useEffect(() => {
    const next = syncEndRuleByArmWithAnchors(schedule, entityOptions)
    if (endRuleSignature(next.endRules) !== endRuleSignature(schedule.endRules)) {
      updateSchedule(schedule.id, { endRules: next.endRules })
    }
  }, [anchorKey, schedule.id, entityOptions?.arms, entityOptions?.visits])
}
